import {useQuery} from '@tanstack/react-query';

import {STORAGE_CROPS, StorageCrop, StorageCropId} from './data/storageAshTransport';

type Input = {
  areaHarvested?: number;
  cropId?: StorageCropId;
  mc?: number; // 1 to 100
  storableHeight?: number;
};

type Output = {
  crop?: StorageCrop;
  cropWeightDried?: number;
  cropWeightStorage?: number;
  volumeRequired?: number;
  areaRequired?: number;
};

export function calculateStorage({areaHarvested, cropId, mc, storableHeight}: Input): Output {
  const crop = cropId ? STORAGE_CROPS[cropId] : undefined;
  const cropWeightDried =
    crop !== undefined && areaHarvested !== undefined ? crop.driedYield * areaHarvested : undefined;
  const cropWeightStorage =
    cropWeightDried !== undefined && mc !== undefined ? cropWeightDried / (1 - mc / 100) : undefined;
  const volumeRequired =
    crop !== undefined && cropWeightStorage !== undefined ? cropWeightStorage / crop.bulkDensity : undefined;
  const areaRequired =
    volumeRequired !== undefined && storableHeight !== undefined ? volumeRequired / storableHeight : undefined;

  return {
    crop,
    cropWeightDried,
    cropWeightStorage,
    volumeRequired,
    areaRequired,
  };
}

export function useStorageCalculator(input: Input) {
  return useQuery({
    queryKey: [...Object.values(input)],
    queryFn: () => calculateStorage(input),
  });
}
